module.exports = __webpack_public_path__ + "images/f94e2c6a37aeb11b5c46008a6a2a498f-bedroom-premium.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/bedroom-premium.jpg
// module id = ./src/assets/images/content/bedroom-premium.jpg
// module chunks = 0